<template>
  <div class="partner_summary">
    <dl>
      <dt>파트너 ID</dt>
      <dd><em class="c">{{  info.partner_id }}</em></dd>
    </dl>
    <dl>
      <dt>파트너 조건</dt>
      <dd><em class="tit">프리매치</em> <em class="c_live">{{  info.match_rate }}%</em></dd>
      <dd><em class="tit">라이브</em> <em class="c_free">{{  info.live_rate }}%</em></dd>
    </dl>
    <dl>
      <dt>하위코드</dt>
      <dd><em class="c">{{ info.child_user }}</em>개</dd>
    </dl>
    <dl>
      <dt>파트너 적립 골드</dt>
      <dd><em class="tit">프리매치</em><em class="c_live">{{  info.partnerMatchPriceAll }}</em> 골드</dd>
      <dd><em class="tit">라이브</em><em class="c_free">{{  info.partnerLivePriceAll }}</em> 골드</dd>
      <dd><em class="tit">전체</em><em class="c">{{  info.partnerTotalPriceAll }}</em> 골드</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "partner-summary",
  data() {
    return {

    }
  },
  computed: {
    info() {
      return this.$store.getters['partner/info'];
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partner/partner-summary.vue